// extracted by mini-css-extract-plugin
export default {"text":"CheckoutSummary_text__klZ4r","card":"CheckoutSummary_card__0Ri6a"};